<template>
    <span>
        <select :class="classes" v-model="selectedHour" :disabled="disabled" @change="updateValue">
            <option v-for="t in hours" :key="t" :value="t">
                {{ $t('common.label_hour', { n: t }) }}
            </option>
        </select>
        <select :class="classes" v-model="selectedMin" :disabled="disabled" @change="updateValue">
            <option v-for="t in mins" :key="t" :value="t">
                {{ $t('common.label_minute', {n : t}) }}
            </option>
        </select>
    </span>
</template>


<script>
const moment = require('@/util/MPMoment')
export default {
    props: {
        value: String,
        disabled: Boolean,
        appendedClass: String,
    },
    data() {
        return {
            hours: [],
            mins: [],

            selectedMoment: undefined,
            selectedHour: '09',
            selectedMin: '00'
        }
    },
    watch: {
        value: function(newValue) {
            console.log('newValue : ', newValue)
            this.selectedMoment = moment(newValue)
            this.initVariables()
        },
    },
    computed: {
        classes: function() {
            if (this.appendedClass == undefined) { return 'input_s' }
            return this.appendedClass
        }
    },
    mounted() {
        this.initVariables()
    },
    methods: {
        initVariables() {
            this.hours = []
            for (let i=0 ; i<24 ; i++) {
                let h = ("0" + i).slice(-2)
                this.hours.push(h)
            }
            this.mins = []
            for (let i=0 ; i<60 ; i+=5) {
                let m = ("0" + i).slice(-2)
                this.mins.push(m)
            }
            if (this.value == undefined) { return }
            this.selectedMoment = moment(this.value)
            let h = this.selectedMoment.hour()
            this.selectedHour = ("0" + h).slice(-2)
            let m = this.selectedMoment.minute()
            this.selectedMin = ("0" + m).slice(-2)
            this.$forceUpdate()
        },


        updateValue() {
            const hour = Number(this.selectedHour)
            const minute = Number(this.selectedMin)
            const updatedDate = moment('2000-01-01', 'YYYY-MM-DD').startOf('days')
            updatedDate.set('hour', hour).set('minute', minute)
            let string = updatedDate.toString()
            this.$emit('input', string)
        }
    }
}
</script>